<template>
  <div v-title data-title="提货" class="mobile">
    <div class="weui-flex">
      <div class="weui-flex__item">
        <wv-swipe :height="200" :autoplay="3000" class="home-banner">
          <wv-swipe-item
            v-for="(advertise, $index) in Advertises"
            :key="$index"
          >
            <div class="swipe-img-div">
              <img v-lazy="advertise" class="lazy-img-fadein" />
            </div>
          </wv-swipe-item>
        </wv-swipe>
      </div>
    </div>

    <div class="weui-flex" style="text-align: center; margin: 20px 0px 0px 0px">
      <div class="weui-flex__item">
        <button class="pickup">提货</button>
      </div>
      <div class="weui-flex__item">
        <button class="logistics" @click="logistics">查物流</button>
      </div>
    </div>

    <div class="weui-cells weui-cells_form" style="margin: 20px 0px">
      <div class="weui-cell">
        <div class="weui-cell__bd">
           <wvi-input
                placeholder="请输入卡号"
                ref="1"
                v-model="model.cardNumber"
                :validate-info="{errormsg:'卡号不可为空'}"
                required
            ></wvi-input>
        </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__bd">
           <wvi-input
                placeholder="请输入提货码"
                ref="1"
                v-model="model.cardPassword"
                :validate-info="{errormsg:'提货码不可为空'}"
                required
            ></wvi-input>
        </div>
      </div>
      <div class="weui-cell weui-cell_vcode" >
        <div class="weui-cell__hd">
           <wvi-input
                placeholder="请输入验证码"
                ref="1"
                v-model="model.code"
                :validate-info="{errormsg:'验证码不可为空'}"
                required
            ></wvi-input>
        </div>
        <div class="weui-cell__bt">
          <img class="weui-vcode-img" :src="queryBindData.verificationCodeImg"  @click="getVerCode()"/>
         
        </div>
        <!-- <div class="weui-cell__ft" @click="getVerCode()">
             <p>换一张</p>
        </div> -->
      </div>
      <div class="weui-cell">
        <a href="javascript:;" class="btn-pickup" @click="deliveryGoods">提货</a>
      </div>
    </div>

    <div class="weui-panel weui-panel_access">
      <div class="weui-panel__hd">注意事项</div>
      <div class="weui-panel__bd" style="padding:10px 10px;">
            <p class="weui-media-box__desc">
              1.江浙沪建议提前两天预约发货，江浙沪以外建议提前三天预约发货。       
            </p>
             <p class="weui-media-box__desc">
              2.请保证您的提货卡在有效期内使用，过期即作废。
            </p>
             <p class="weui-media-box__desc">
              3.提货卡不设找零，不可兑换现金。
            </p>
             <p class="weui-media-box__desc">
              4.为保证准确及时送达，请准确填写收件人相关信息。
            </p>
             <p class="weui-media-box__desc">
              5.一张卡只能使用1次。
            </p>
            <p class="weui-media-box__desc">
              6.由于今夏高温天气持续，大闸蟹上市时期整体较晚，为保证品质，较大规格的大闸蟹（尤其是公蟹）套餐建议10月中旬以后进行提货。
            </p>
      </div>
    </div>
  </div>
</template>

<script>
import Vue  from 'vue'
import { Toast } from "we-vue";
import {Dialog} from 'we-vue';
import banner1 from "@/assets/img/banner1.png";
import banner2 from "@/assets/img/banner2.png";
import banner3 from "@/assets/img/banner3.png";
import gyhdzj from "@/assets/img/gyhdzj.jpg";
const imagesList = [gyhdzj];
export default {
  name: "deliverygoods",
  data() {
    return {
      Advertises: imagesList,
      queryBindData:{
          verificationCodeImg:""
      },
      model:{
        cardNumber:"",
        cardPassword:"",    
        code: "",
        timestamp:""
      },
      VIPCards:[
        /*
        "3390606","90622","90621","90606","90607","90608","90609","90610",
        "90503","90504",        
        "90530","90531","90532","90533","90534","90535","90536","90537","90538","90539","90540","90541","90542","90543","90544","90545","90546","90547","90548","90549",
        "90554","90555","90556","90557","90558","90559","90560","90561",
        "90562","90563","90564","90565","90566","90567","90568","90569",
        "90572",
        "90573","90574","90575","90576","90577","90578","90579","90580","90581","90582",
        "90585","90586","90587","90588","90589","90590","90591","90592","90593","90594",
        */
      ]
    };
  },
  created() {
  
  this.getVerCode();

     let currentDate=Vue.prototype.dateFormat(new Date(),"yyyy-MM-dd hh:mm:ss");
     let startDate="2026-10-12 00:00:00";
     let endDate="2026-12-31 23:59:59";
     
    //  if(Vue.prototype.dateDiff(currentDate,endDate)){
    //       Dialog.confirm({
    //         className:'textLeft!important',
    //         showConfirmButton:true,
    //         showCancelButton:false,
    //         title: "通知",
    //         message: "<span style='display:inline-block;text-align:left;'>尊敬的客户：<br/><span style='text-indent: 2em;display:inline-block;text-align:left;'>非常抱歉！由于今年暖冬影响，精品大闸蟹减产，而“今月醉”旨在为客户提供最鲜美的产品体验，为保证您的美食权益，我们已于12月6日提前关闭兑换系统。若您的蟹卡今年到期，可联系客服进行延期。给您带来不便，敬请谅解。<span/><span/>"
    //         }).then(() => {
    //       });
    //   }
      if(Vue.prototype.dateDiff(currentDate,startDate)){
          Dialog.alert({
            showConfirmButton:false,
            // title: "提货即将开放",
            // message: "今月醉高邮湖大闸蟹兑换系统即将开放，敬请期待。如有疑问，请联系相关人员。"
            title: "提货即将开放",
            message: "大闸蟹预计将于10月12日0点开放兑换，敬请留意！"
            }).then(() => {
          });
      }
      else if(Vue.prototype.dateDiff(endDate,currentDate)){
          Dialog.alert({
            showConfirmButton:false,
            title: "提货已结束",
            message: "大闸蟹提货已结束，如有疑问，请联系客服人员！"
            // title: "提货即将开放",
            // message: "今月醉高邮湖大闸蟹兑换系统即将开放，敬请期待！"
            //title: "提货已结束",
            //message: "<span style='display:inline-block;text-align:left;'>尊敬的客户：<br/><span style='text-indent: 2em;display:inline-block;text-align:left;'>非常抱歉！由于今年暖冬影响，精品大闸蟹减产，而“今月醉”旨在为客户提供最鲜美的产品体验，为保证您的美食权益，我们已于12月6日提前关闭兑换系统。若您的蟹卡今年到期，可联系客服进行延期。给您带来不便，敬请谅解。<span/><span/>"
            }).then(() => {
          });
      }
  
  },
  methods: {
    //获取图形验证码
    getVerCode() {
      this.model.timestamp=new Date().getTime();
      this.$http
        .get(this.GLOBAL.BASE_URL + `api/crab/getverificationcode?timestamp=${this.model.timestamp }`)
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              this.queryBindData.verificationCodeImg = `data:image/png;base64,${rep.Data}`;
            } else {
              Toast.fail(rep.Message);
            }
          },
          function(d) {
            console.log(d);
          }
        );
    },
     validatesave: function() {
      var com = this.$refs;
      var flag = true;
      for (var c in com) {
        this.$refs[c].validate();
        flag = this.$refs[c].valid;

        if (!flag) return flag;
      }
      return flag;
    },
    isVIPCard(){
      var flag = false;
      for(var i=0;i<this.VIPCards.length;i++)
      {
        flag = this.VIPCards[i]==this.model.cardNumber;
        if(flag){
          break;
        }
      }
      return flag;
    },
    //提货
    deliveryGoods(){
      var flag = false;
     let currentDate=Vue.prototype.dateFormat(new Date(),"yyyy-MM-dd");
     let endDate="2025-12-31 23:59:59";
     let endDateNoVIP="2025-12-31 23:59:59";//非VIP截止7日0点
     let endDateVIP="2025-12-31 23:59:59";//VIP客户提货时间截止年底
     var isVIP = this.isVIPCard();//(this.model.cardNumber=="3390606"||this.model.cardNumber=="90622"||this.model.cardNumber=="90621"||this.model.cardNumber=="90606"||this.model.cardNumber=="90607"||this.model.cardNumber=="90608"||this.model.cardNumber=="90609"||this.model.cardNumber=="90610");
      if(Vue.prototype.dateDiff(endDateNoVIP,currentDate)&&!isVIP||Vue.prototype.dateDiff(endDateVIP,currentDate)&&isVIP)
      {
        Dialog.confirm({
          className:'textLeft!important',
          showConfirmButton:true,
          showCancelButton:false,
          title: "温馨提示",
          message: "<span style='display:inline-block;text-align:left;'>尊敬的客户：<br/><span style='text-indent: 2em;display:inline-block;text-align:left;'>为保证品质，较大规格的大闸蟹（尤其是公蟹）套餐，建议10月中旬以后进行提货。<span/><span/>"
          }).then(() => {
        });
      }else{
        if(Vue.prototype.dateDiff(currentDate,endDate)){
/*
            Dialog.confirm({
              showCancelButton:true,
              title: "温馨提示",
              message: "由于气候原因，今年公蟹上市会继续延迟至10月底，为保证品质，包含公蟹套餐的客人建议10月底之后进行提货",
              }).then((action) => {
                */
                //if(action === 'confirm')
                //{
                  flag=true;
                  if (!this.validatesave()) {
                    return;
                  }
                  if(flag){
                    let promise= this.$http.post(this.GLOBAL.BASE_URL + "api/crab/checkcrab", this.model,{emulateJSON:true})
                    .then(function(d) {
                            var rep = JSON.parse(d.bodyText);
                            if (rep.Success) {
                                let data=rep.Data;
                                if(data.state){
                                    this.$router.push({
                                        path: "/page/editdeliveryInfo",
                                        query: { CrabType: JSON.stringify(data.CrabType),CrabGuid:data.CrabGuid,CType:data.CType}
                                    });
                                }else{
                                    Toast.fail(data.message);
                                }
                            } else {
                                Toast.fail(rep.Message);
                            }
                    });
                  }
                //}
            //});
            
        }else{
          flag=true;
        if (!this.validatesave()) {
              return;
          }
          if(flag){
            let promise= this.$http.post(this.GLOBAL.BASE_URL + "api/crab/checkcrab", this.model,{emulateJSON:true})
            .then(function(d) {
                    var rep = JSON.parse(d.bodyText);
                    if (rep.Success) {
                        let data=rep.Data;
                        if(data.state){
                            this.$router.push({
                                path: "/page/editdeliveryInfo",
                                query: { CrabType: JSON.stringify(data.CrabType),CrabGuid:data.CrabGuid,CType:data.CType}
                            });
                        }else{
                            Toast.fail(data.message);
                        }
                    } else {
                        Toast.fail(rep.Message);
                    }
            });
          }
        }
      }
    },
    logistics(){
        this.$router.push({path:"/page/logistics"});
    }

  },
};
</script>

<style scoped>
.textLeft{text-align: left !important;}
.mobile{
  overflow: hidden;
}
.home-banner{
}
.swipe-img-div{
    line-height: 200px;
    height: 200px;
}
.pickup {
  width: 80px;
  height: 80px;
  border-radius: 50px;
  border: none;
  background: #d28a21;
  color: #fff;
  font-size: 14px;
}
.logistics {
  width: 80px;
  height: 80px;
  border-radius: 50px;
  border: none;
  background: #d5d5d6;
  font-size: 14px;
}
.btn-pickup {
  width: 100%;
  background: #d28a21;
  position: relative;
  display: block;
  box-sizing: border-box;
  font-size: 14px;
  text-align: center;
  text-decoration: none;
  color: #fff;
  line-height: 2.55555556;
  border-radius: 25px;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  overflow: hidden;
}
.btn-pickup :active{
    
  color: #fff;
}
.weui-media-box__desc{
    line-height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/crab/deliverygoods.vue